export default __webpack_public_path__ + "static/151-min-min-6d431cd34f408573d19947bba5ca160e.jpg";